import { useRecoilValue } from 'recoil';
import { authenticationStateAtom } from '../state/authenticationState';
import { useEffect } from 'react';
import * as braze from "@braze/web-sdk";
import { useCustomer } from './useCustomer';

export const useBraze = () => {
  const { user } = useRecoilValue(authenticationStateAtom);
  const { customer, loadingCustomer } = useCustomer();

  useEffect(() => {
    if (customer?.id) {
      braze.changeUser(customer.id);
    }
    if (user?.email) {
        braze.getUser()?.setEmail(user?.email);
    }
  }, [customer?.email, customer?.id, loadingCustomer]);
}